exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".renderArea[data-v-33c50815]{display:inline-block}", ""]);

// exports
